import { i18nFunct } from '@lucid/gatsby-theme-lucid';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useContext } from 'react';

import LayoutContext from '../../contexts/layoutContext';
import {
  Drupal_ParagraphAdditionalResources,
  Drupal_ParagraphCtaButton,
  Drupal_ParagraphMarketoForm
} from '../../generated/graphql';
import Link from '../link/link';
import './additional-resources.scss';
import useMarketoLink from '../../hooks/use-marketo-link';

interface AdditionalResourcesProps {
  resources: Drupal_ParagraphAdditionalResources[];
  blurb?: string | null | undefined;
  ctas: Drupal_ParagraphCtaButton[];
}

const AdditionalResources = ({
  resources,
  blurb,
  ctas
}: AdditionalResourcesProps) => {
  const { language } = useContext(LayoutContext);

  const { i18nData } = useStaticQuery(
    graphql`
      {
        i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
          edges {
            node {
              name
              childSrcJson {
                mktg_ct_cs_additional_resources
                mktg_ct_cs_prefooter_title
                mktg_ct_all_get_a_quote
                mktg_ct_all_request_a_demo
                mtkg_submit_policy
              }
            }
          }
        }
      }
    `
  );

  const i18n = i18nFunct(i18nData, language.i18nKey);
  const getMarketoLink = useMarketoLink(language);

  return (
    <section className="additional-resources">
      <div className="additional-resources__content">
        <div className="additional-resources__list">
          <h3 className="additional-resouces__list-title">
            {i18n('mktg-ct-cs-additional-resources')}
          </h3>
          <ul>
            {resources
              .filter(ar => ar.fieldResourceUrl)
              .map(ar => {
                return (
                  <li key={ar.fieldResourceText!}>
                    <Link to={ar.fieldResourceUrl!} inverse>
                      {ar.fieldResourceText}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
        <div className="additional-resources__cta">
          <h2 className="additional-resouces__cta-title">
            {blurb || i18n('mktg-ct-cs-prefooter-title')}
          </h2>
          {ctas.map((cta, i) => {
            const buttonText = cta.fieldButtonText;
            const defaultText =
              i === 0
                ? i18n('mktg-ct-all-get-a-quote')
                : i18n('mktg-ct-all-request-a-demo');
            const fieldMarketo = cta.fieldMarketo
              ? (cta.fieldMarketo.entity as Drupal_ParagraphMarketoForm)
              : null;
            if (cta.fieldButtonLink) {
              return (
                <Link
                  secondary
                  inverse
                  className="additional-resources__cta-link"
                  key={cta.fieldButtonLink}
                  to={cta.fieldButtonLink}
                >
                  {buttonText || defaultText}
                </Link>
              );
            }
            if (fieldMarketo?.fieldMarketoId) {
              const { url, copy } = getMarketoLink(
                fieldMarketo.fieldMarketoId
              )!;
              return (
                <Link
                  asButton
                  key={fieldMarketo.fieldMarketoId}
                  primary={!cta.fieldIsSecondary}
                  secondary={!!cta.fieldIsSecondary}
                  to={url}
                >
                  {buttonText || copy}
                </Link>
              );
            }
            return;
          })}
        </div>
      </div>
    </section>
  );
};

export default AdditionalResources;
